// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__whQiJ","img":"Footer_img__v3UQg","copyRight":"Footer_copyRight__lNv5r"};